var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { TableHeaderStructure } from '../components/TableHeaderStructure';
import { Label } from '../../../atoms/Label';
// Styles
import { getTableHeaderStylesByVariant } from './getTableHeaderStylesByVariant';
// Utils
import styled from 'styled-components';
import { grey } from '../../../common/styles/colours';
export var StyledTableHeader = styled(TableHeaderStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  padding: 8px 12px;\n  height: 40px;\n  display: table-cell;\n  min-width: ", ";\n  width: ", ";\n  background-color: ", ";\n\n  ", " {\n    width: 100%;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    white-space: break-spaces;\n    word-break: break-all;\n    overflow: hidden;\n  }\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  padding: 8px 12px;\n  height: 40px;\n  display: table-cell;\n  min-width: ", ";\n  width: ", ";\n  background-color: ", ";\n\n  ", " {\n    width: 100%;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    white-space: break-spaces;\n    word-break: break-all;\n    overflow: hidden;\n  }\n\n  ", "\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return minWidth + "px";
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth + "px";
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return "" + ((_b = theme.backgroundPrimary) !== null && _b !== void 0 ? _b : grey[100]);
}, Label, function (_a) {
    var styleVariant = _a.styleVariant;
    return getTableHeaderStylesByVariant(styleVariant);
});
var templateObject_1;
//# sourceMappingURL=StyledTableHeader.js.map